import { Link } from "react-router-dom";
import { AlertTriangle, Clock, FileQuestion, Lock, ServerCrash, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

const MAP = {
  404: { icon: FileQuestion, title: "File not found", text: "This file is no longer available. It may have been deleted or the link is incorrect." },
  410: { icon: Clock, title: "This file has expired", text: "The file reached its expiration time and was automatically deleted." },
  451: { icon: Lock, title: "File unavailable", text: "This file has been blocked and cannot be accessed." },
  403: { icon: Lock, title: "Permission denied", text: "You do not have access to this resource." },
  429: { icon: AlertTriangle, title: "Too many requests", text: "Please slow down and try again in a moment." },
  network: { icon: WifiOff, title: "Network error", text: "Please check your connection and try again." },
  500: { icon: ServerCrash, title: "Something went wrong", text: "We hit a problem on our side. Please try again." },
};

export function ErrorState({ status = 500, title, text, action }) {
  const cfg = MAP[status] || MAP[500];
  const Icon = cfg.icon;
  return (
    <div className="mx-auto max-w-md px-4 py-16 text-center animate-rise" data-testid={`error-state-${status}`}>
      <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-slate-100 text-slate-500"><Icon className="h-7 w-7" /></div>
      <h1 className="mt-6 text-2xl font-bold tracking-tight text-slate-900">{title || cfg.title}</h1>
      <p className="mt-2 text-sm leading-relaxed text-slate-500">{text || cfg.text}</p>
      <div className="mt-6">{action || <Button asChild className="rounded-full bg-indigo-600 hover:bg-indigo-700"><Link to="/" data-testid="error-home-link">Upload a file</Link></Button>}</div>
    </div>
  );
}

export function statusFromError(error) {
  if (error?.code === "ERR_NETWORK") return "network";
  return error?.response?.status || 500;
}
